var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3712",
    "data-name": "Group 3712",
    xmlns: "http://www.w3.org/2000/svg",
    width: 148.276,
    height: 20.861,
    viewBox: "0 0 148.276 20.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M23.864,10.6H16.487l-2.242-6.69a.812.812,0,0,0-1.524,0L10.479,10.6H3.052a.8.8,0,0,0-.8.8.59.59,0,0,0,.015.135A.771.771,0,0,0,2.6,12.1l6.063,4.273L6.337,23.138a.8.8,0,0,0,.276.9.776.776,0,0,0,.451.2.983.983,0,0,0,.5-.181l5.917-4.217L19.4,24.056a.94.94,0,0,0,.5.181.72.72,0,0,0,.446-.2.8.8,0,0,0,.276-.9L18.3,16.373l6.013-4.313.145-.125a.841.841,0,0,0,.261-.537A.849.849,0,0,0,23.864,10.6Z",
    transform: "translate(-2.25 -3.375)",
    fill: "#fd3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-2",
    "data-name": "Icon ionic-ios-star",
    d: "M23.864,10.6H16.487l-2.242-6.69a.812.812,0,0,0-1.524,0L10.479,10.6H3.052a.8.8,0,0,0-.8.8.59.59,0,0,0,.015.135A.771.771,0,0,0,2.6,12.1l6.063,4.273L6.337,23.138a.8.8,0,0,0,.276.9.776.776,0,0,0,.451.2.983.983,0,0,0,.5-.181l5.917-4.217L19.4,24.056a.94.94,0,0,0,.5.181.72.72,0,0,0,.446-.2.8.8,0,0,0,.276-.9L18.3,16.373l6.013-4.313.145-.125a.841.841,0,0,0,.261-.537A.849.849,0,0,0,23.864,10.6Z",
    transform: "translate(29.203 -3.375)",
    fill: "#fd3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-3",
    "data-name": "Icon ionic-ios-star",
    d: "M23.864,10.6H16.487l-2.242-6.69a.812.812,0,0,0-1.524,0L10.479,10.6H3.052a.8.8,0,0,0-.8.8.59.59,0,0,0,.015.135A.771.771,0,0,0,2.6,12.1l6.063,4.273L6.337,23.138a.8.8,0,0,0,.276.9.776.776,0,0,0,.451.2.983.983,0,0,0,.5-.181l5.917-4.217L19.4,24.056a.94.94,0,0,0,.5.181.72.72,0,0,0,.446-.2.8.8,0,0,0,.276-.9L18.3,16.373l6.013-4.313.145-.125a.841.841,0,0,0,.261-.537A.849.849,0,0,0,23.864,10.6Z",
    transform: "translate(60.655 -3.375)",
    fill: "#fd3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-4",
    "data-name": "Icon ionic-ios-star",
    d: "M23.864,10.6H16.487l-2.242-6.69a.812.812,0,0,0-1.524,0L10.479,10.6H3.052a.8.8,0,0,0-.8.8.59.59,0,0,0,.015.135A.771.771,0,0,0,2.6,12.1l6.063,4.273L6.337,23.138a.8.8,0,0,0,.276.9.776.776,0,0,0,.451.2.983.983,0,0,0,.5-.181l5.917-4.217L19.4,24.056a.94.94,0,0,0,.5.181.72.72,0,0,0,.446-.2.8.8,0,0,0,.276-.9L18.3,16.373l6.013-4.313.145-.125a.841.841,0,0,0,.261-.537A.849.849,0,0,0,23.864,10.6Z",
    transform: "translate(92.108 -3.375)",
    fill: "#fd3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-5",
    "data-name": "Icon ionic-ios-star",
    d: "M23.864,10.6H16.487l-2.242-6.69a.812.812,0,0,0-1.524,0L10.479,10.6H3.052a.8.8,0,0,0-.8.8.59.59,0,0,0,.015.135A.771.771,0,0,0,2.6,12.1l6.063,4.273L6.337,23.138a.8.8,0,0,0,.276.9.776.776,0,0,0,.451.2.983.983,0,0,0,.5-.181l5.917-4.217L19.4,24.056a.94.94,0,0,0,.5.181.72.72,0,0,0,.446-.2.8.8,0,0,0,.276-.9L18.3,16.373l6.013-4.313.145-.125a.841.841,0,0,0,.261-.537A.849.849,0,0,0,23.864,10.6Z",
    transform: "translate(123.56 -3.375)",
    fill: "#cecece"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatings);
export default __webpack_public_path__ + "static/media/ratings.0fcc7fb956f655de2f51d862e3f4a17c.svg";
export { ForwardRef as ReactComponent };